import React, {useState} from "react";
import PropTypes from "prop-types";
import {Nav, NavItem, NavLink, TabContent, TabPane} from "reactstrap";
import classnames from "classnames";
import AddKeywordForm from "./AddKeywordForm";
import {useCurrentUserQuery} from "../../../../queries/CurrentUser";
import {hasUserEditorPermissionOnFeature} from "../../../../shared/helpers/permissions";
import {PLATFORM_FEATURE_IDENTITY_MONITOR_PROJECTS} from "../../../../shared/helpers/features";
import getIntelligenceBlock from "../../profile_utils";
import ProfilePreferencesMessage from "../../../../shared/components/ProfilePreferencesMessage";
import {getPattern} from "../../../../shared/helpers/validators";


const DarkWebKeywordForm = ({
                              project,
                              keywords,
                              keywordTypes,
                              organization
                            }) => {
  const [activeTab, setActiveTab] = useState(0);
  const {data: dataCurrentUser} = useCurrentUserQuery();
  const {
    block: intelligenceBlock,
    unblockDate: unblockDate
  } = getIntelligenceBlock(organization, 'last_project_keyword_update_dt')
  const [darkWebKeywords, setDarkWebKeywords] = useState(keywordTypes.map((type) => (keywords.filter((k) => k.type === type))))
  const previousDarkWebKeywords = keywordTypes.map((type) => (keywords.filter((k) => k.type === type)))
  const [formattedModalMessages, setFormattedModalMessages] = useState([])
  const [submitAll, setSubmitAll] = useState({toSubmit: [], toSubmitType: []})
  const [onlyAddition, setOnlyAddition] = useState(false)
  const toggleTab = (tab) => {
    if (activeTab !== tab) setActiveTab(tab);
  };
  const getChanges = (mode, idx, type) => {

    let result = []
    keywordTypes.map((keywordType, index) => {
      let toBeAdded = []
      let toBeDeleted = []
      const typeResult = {}
      typeResult.type = keywordType
      const getDifference = (array1, array2) => {
        return array1.filter(object1 => {
          return !array2.some(object2 => {
            return object1.value === object2.value;
          });
        });
      }
      const difference = getDifference(darkWebKeywords[index], previousDarkWebKeywords[index])
      const reverseDiff = getDifference(previousDarkWebKeywords[index], darkWebKeywords[index])
      const regexErrors = difference.filter((resource) => {
        const passesRegex = new RegExp(getPattern(keywordType)).test(resource.value)
        if (!passesRegex) return resource
      })
      let toBeEdited = difference.filter((resource) => resource.uid && !resource?.isNew)
      if (mode !== 'deletion') {
        toBeAdded = difference.filter((resource) => !resource?.uid && resource.isNew)
      } else {
        if (type === keywordType && previousDarkWebKeywords[index][idx]) {
          if (toBeEdited.length) toBeDeleted = [previousDarkWebKeywords[index][idx]]
          else toBeDeleted = [darkWebKeywords[index][idx]]
        }
        toBeEdited = toBeEdited.filter((resource) => {
          reverseDiff.filter((res) => !resource.value !== res.value && resource.uid === res.uid)
        })
      }
      typeResult.result = {
        toBeAdded: toBeAdded,
        toBeEdited: toBeEdited,
        toBeDeleted: toBeDeleted,
        regexErrors: regexErrors
      }
      result.push(typeResult)
    })
    return result
  }
  const getFormattedModalText = (mode, deletionUid, type) => {
    const changes = getChanges(mode, deletionUid, type)
    let messages = []
    let onlyAdditions = []
    keywordTypes.map((keywordType, index) => {
      const toBeAdded = changes[index].result.toBeAdded.map(a => a?.value)
      const toBeDeleted = changes[index].result.toBeDeleted.map(a => a?.value)
      const toBeEdited = changes[index].result.toBeEdited.map(a => a?.value)
      const regexErrors = changes[index].result.regexErrors.map(a => a?.value)
      const forDeletion = toBeDeleted.filter(function (val) {
        return val !== undefined && !regexErrors.includes(val);
      });
      const forAddition = toBeAdded.filter(function (val) {
        return val !== undefined && !regexErrors.includes(val);
      });
      const forEdition = toBeEdited.filter(function (val) {
        return val !== undefined && !regexErrors.includes(val);
      });
      let message = ProfilePreferencesMessage({
        preferences: {
          forAddition: forAddition,
          forEdition: forEdition,
          forDeletion: forDeletion,
          regexErrors: regexErrors,
        }, mode: mode,
        preferencesType: changes[index].type
      })
      const deletion = !!message.preferences.forDeletion.length
      const addition = !!message.preferences.forAddition.length
      const edition = !!message.preferences.forEdition.length
      const regexErr = !!message.preferences.regexErrors.length
      if (!addition && !edition && !deletion && !regexErr) message = null
      if (message){
        if ((addition || regexErr) && !deletion && !edition) {
          onlyAdditions.push(true)
        } else onlyAdditions.push(false)
        messages[index] = message
      }

    })
    if (onlyAdditions.every(v => v === true)) setOnlyAddition(true)
    else setOnlyAddition(false)
    return messages
  }
  const onChangeHandler = (change, type) => {
    const formIndex = change.target.name.split('.')[1]
    const newResource = {
      value: change.target.value,
      isNew: true
    }
    keywordTypes.map((keywordType, index) => {

      if (keywordType === type) {

        if (darkWebKeywords[index].length) {
          if (darkWebKeywords[index][formIndex]?.uid) {
            newResource.isNew = false
            newResource.uid = darkWebKeywords[index][formIndex].uid
          }
          darkWebKeywords[index][formIndex] = newResource
        } else darkWebKeywords[index].push(newResource)

      }
      setFormattedModalMessages(getFormattedModalText())

    })
  }
  const onSubmitHandler = () => {
    keywordTypes.map((keywordType, index) => {
      if (darkWebKeywords[index].length) {
        setFormattedModalMessages(getFormattedModalText())
      }
    })
  }
  const onDeleteHandler = (idx, type, onlyMessage) => {
    if (!onlyMessage) {
      keywordTypes.map((keywordType, index) => {
          if (keywordType === type && darkWebKeywords[index].length) {
            const tmpResources = darkWebKeywords[index]
            tmpResources.splice(idx, 1)
            darkWebKeywords[index] = tmpResources
            setDarkWebKeywords(darkWebKeywords)
          }
        }
      )
    }
    setFormattedModalMessages(getFormattedModalText('deletion', idx, type))
  }

  const onSubmitAll = (allKeywords, index) => {
    const typesToUpdate = []
    keywordTypes.map((type, idx) => {
      darkWebKeywords[idx].map((res) => {
        allKeywords.map((res2) => {
          if(res.value === res2.value){
            res.isNew = false
            res.uid = res2.uid
          }
        })
      })
      if (idx !== index) {
        typesToUpdate.push(type)
      }
      setSubmitAll({toSubmit: allKeywords, toSubmitType: typesToUpdate})
    })
  }

  return (
    <div className="tabs tabs--bordered-bottom">
      <div className="tabs__wrap">
        <Nav tabs>
          {
            keywordTypes.map((type, index) => (
              <NavItem key={index}>
                <NavLink
                  className={classnames({active: activeTab === index})}
                  onClick={() => toggleTab(index)}
                >{type.toUpperCase()}</NavLink>
              </NavItem>
            ))
          }
        </Nav>
        <TabContent activeTab={activeTab}>
          {
            keywordTypes.map((type, index) =>
              <TabPane tabId={index} key={index} onChange={(a) => onChangeHandler(a, type)}>
                <AddKeywordForm
                  key={index}
                  project={project}
                  keywords={darkWebKeywords[index].filter((k) => k.type === type)}
                  all_keywords={darkWebKeywords}
                  organization={organization}
                  keywordType={type}
                  allKeywordTypes={keywordTypes}
                  messages={formattedModalMessages}
                  buttonsDisabled={
                    !hasUserEditorPermissionOnFeature(
                      dataCurrentUser?.data?.modules || [],
                      PLATFORM_FEATURE_IDENTITY_MONITOR_PROJECTS
                    )
                  }
                  deleteHandler={(index, type, onlyMessage) => onDeleteHandler(index, type, onlyMessage)}
                  submitHandler={() => onSubmitHandler()}
                  intelligenceBlock={intelligenceBlock}
                  unblockDate={unblockDate}
                  submit={(allKeywords) => onSubmitAll(allKeywords, index)}
                  submitAll={submitAll}
                  onlyAddition={onlyAddition}
                />
              </TabPane>
            )
          }
        </TabContent>
      </div>
    </div>
  )
}


DarkWebKeywordForm.propTypes = {
  project: PropTypes.object.isRequired,
  keywords: PropTypes.array.isRequired,
  keywordTypes: PropTypes.arrayOf(PropTypes.string).isRequired,
  organization: PropTypes.object.isRequired
}


export default DarkWebKeywordForm;
